<h2 mat-dialog-title>
  @let idTagResult = idTag();
  @if (idTagResult) {
    <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#edit-s"></use></svg>
    Rediger brik
  } @else {
    <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#token-s"></use></svg>
    Opret brik
  }
</h2>
<button class="btn-close btn-icon" mat-dialog-close>
  <mat-icon class="material-icons">close</mat-icon>
</button>

<mat-dialog-content class="dialog-content">
  <form [formGroup]="step1FormGroup">
    <div class="step1">
      <div class="form-row">
        <adm-org-typeahead
          [disabled]="isEdit()"
          [initialId]="idTagResult?.organizationId ?? undefined"
          [resetTrigger]="resetOrgTrigger()"
          (clearTypeAhead)="resetOrganization()"
          (itemSelected)="getDepartments($event)" />
      </div>
      <div class="form-row">
        <adm-dep-typeahead
          [disabled]="isEdit() || this.step1FormGroup.controls.selectedDepartmentId.disabled"
          [organizationId]="idTagResult?.organizationId ?? step1FormGroup.controls.organizationId.value"
          [departmentId]="initialDepartmentId() ?? null"
          (itemSelected)="selectDepartment($event)"
          (departmentFetched)="departmentFetched($event)"
          (clearTypeAhead)="resetDepartment()"
          [resetTrigger]="resetDepartmentFilterSignal()" />
      </div>
      <div class="form-row">
        <mat-form-field>
          <mat-label>Afdelingens adresse</mat-label>
          <input type="text" matInput required="" formControlName="shippingAddress" readonly />
          <mat-hint>Hvortil brikken bliver sendt. </mat-hint>
        </mat-form-field>
      </div>
      <div class="form-row margin--bottom-l">
        <mat-slide-toggle formControlName="showAltDeliveryAddress" [checked]="" color="primary"
          >Angiv anden modtageradresse for brik.
        </mat-slide-toggle>
      </div>
      @if (step1FormGroup.controls.showAltDeliveryAddress.value === true) {
        <div class="form-row">
          <adm-dep-address-typeahead
            [parentFormGroup]="step1FormGroup"
            [addressWithoutDARValidation]="false"
            [initialAddress]="initialAltAddress()"
            (addressSelected)="selectAltAddress($event)" />
        </div>
      }
      <div class="form-row">
        <mat-form-field>
          <mat-label>Att.</mat-label>
          <input
            type="text"
            placeholder="Hvem skal modtage?"
            maxlength="30"
            placeholder="Att."
            matInput
            formControlName="attention"
            [readonly]="isLimited()" />
          <mat-hint>Navn på modtager</mat-hint>
        </mat-form-field>
      </div>
      <div class="form-row">
        <mat-form-field>
          <mat-label>Beskrivelse</mat-label>
          <input matInput placeholder="Navn eller registreringsnummer" formControlName="description" value="" />
          <mat-error> Indtast venligst en beskrivelse </mat-error>
        </mat-form-field>
      </div>
      <div class="form-row">
        <mat-form-field>
          <mat-label>ID</mat-label>
          <input type="text" maxlength="30" placeholder="ID" matInput formControlName="externalReference" />
          <mat-hint>PSP nummer, AZident</mat-hint>
        </mat-form-field>
      </div>
    </div>
    @if (isFleetIdTag(idTagResult)) {
      <div class="form-row">
        <div>
          <adm-g4-agreement-number [control]="step1FormGroup.controls.agreementNumber" />
          <mat-hint class="tiny-text">
            Indtastet aftalenr bliver brugt til at fakturere alt forbrug for brikkerne tilknyttet brugeren
          </mat-hint>
        </div>
      </div>
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  @if (isEdit()) {
    <div class="unit-identifier">
      @if (idTagResult?.printedId) {
        <span>Brik ID:</span>
        {{ idTagResult?.printedId }}
      } @else {
        <span>Brik beskrivelse:</span>
        {{ idTagResult?.description }}
      }
    </div>
  }

  <button class="actions__button margin--right-2" mat-dialog-close type="button" mat-button>Annuller</button>
  @if (isEdit()) {
    <button
      class="actions__button"
      type="button"
      mat-flat-button
      color="primary"
      [disabled]="step1FormGroup.invalid || saving()"
      [class.spinner]="saving()"
      (click)="saveIdTagAndClose()">
      Gem
    </button>
  } @else {
    <button
      class="actions__button"
      type="button"
      mat-flat-button
      color="primary"
      [disabled]="step1FormGroup.invalid || saving() || step1FormGroup.controls.selectedDepartmentId.disabled"
      [class.spinner]="saving()"
      (click)="saveIdTagAndContinue()">
      Gem og behandl brik
    </button>
  }
</mat-dialog-actions>
